const guiColors = {
    'motion-primary': '#66ccff',
    'motion-primary-transparent': '#66ccffe6',
    'motion-tertiary': '#4da3cc',

    'looks-secondary': '#66ccff',
    'looks-transparent': '#66ccff59',
    'looks-light-transparent': '#66ccff26',
    'looks-secondary-dark': '#4da3cc',

    'extensions-primary': '#66ccff',
    'extensions-tertiary': '#4da3cc',
    'extensions-transparent': '#66ccff59',
    'extensions-light': '#b3e6ff',

    'drop-highlight': '#b3e6ff'
};

const blockColors = {
    checkboxActiveBackground: '#66ccff',
    checkboxActiveBorder: '#4da3cc'
};

export {
    guiColors,
    blockColors
};